import { useState } from 'react';
import { toast } from 'sonner';
import { KeyRound, Loader2 } from 'lucide-react';
import { Section, Field } from './_shared';

export default function PasswordPanel({ cx }) {
  const [cur, setCur] = useState('');
  const [nx, setNx] = useState('');
  const [busy, setBusy] = useState(false);
  const change = async () => {
    if (!cur || !nx || nx.length < 4) { toast.error('New password must be at least 4 characters'); return; }
    setBusy(true);
    try { await cx.post('/auth/change-password', { current_password: cur, new_password: nx }); toast.success('Password updated'); setCur(''); setNx(''); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Could not update password'); }
    finally { setBusy(false); }
  };
  return (
    <Section title="Change Password">
      <div className="space-y-4 max-w-md">
        <Field label="Current password"><input type="password" className="lux-input" value={cur} onChange={(e) => setCur(e.target.value)} /></Field>
        <Field label="New password"><input type="password" className="lux-input" value={nx} onChange={(e) => setNx(e.target.value)} /></Field>
        <button onClick={change} disabled={busy} data-testid="admin-password-save" className="btn-primary text-sm">{busy ? <Loader2 size={14} className="animate-spin" /> : <KeyRound size={14} />} Update password</button>
      </div>
    </Section>
  );
}
